angular.module('dealerware.web.data').factory('DealerwareLookerQueryModel', function($http, Model, $q) {
    var model = new Model({
        baseEndpoint: '/looker/query',
        customActions: {
            create: {
                method: 'POST',
                rootNodeRequest: 'query',
                ignoreAssociations: true
            }
        }
    });

    return model;
});